import React from 'react'
import { SvgIconProps } from './Home'

const SvgAddIcon = ({ fill, width, height }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ?? "50"}
    height={height ?? "50"}
    fill="none"
    viewBox="0 0 50 50"
  >
    <path
      fill={fill ?? "#353535"}
      d="M31.875 24.5c-.654-1.136-1.471-1.948-2.288-2.597-.164 0-.164-.163-.164-.325s0-.325.164-.487c.817-.974 1.307-2.435 1.307-3.734 0-2.922-2.452-5.357-5.394-5.357s-5.394 2.435-5.394 5.357c0 1.299.49 2.598 1.47 3.572 0 .162.164.324.164.649 0 .162 0 .162-.163.325a7.536 7.536 0 00-2.452 2.597C17.817 26.61 17 29.208 17 31.805c0 1.137.49 2.273 1.308 3.247C19.615 36.35 22.23 37 25.5 37c3.27 0 5.885-.812 7.192-1.948C33.51 34.24 34 33.104 34 31.805c0-2.435-.817-5.195-2.125-7.305zM25.5 22.714c2.615 0 6.212 3.572 6.212 9.091 0 .65-.164 1.137-.654 1.624-.818.649-3.106 1.298-5.558 1.298-2.615 0-4.74-.487-5.558-1.298-.49-.487-.654-.974-.654-1.624 0-5.52 3.597-9.09 6.212-9.09zm0-2.11c-1.798 0-3.106-1.461-3.106-3.247 0-1.786 1.471-3.247 3.106-3.247 1.798 0 3.27 1.461 3.27 3.247 0 1.786-1.472 3.247-3.27 3.247z"
    ></path>
    <path
      fill={fill ?? "#353535"}
      d="M22.721 30.994c.49.487 1.798 1.46 1.962 1.623l.817.65.654-.65s1.47-1.136 1.961-1.786c.654-.487.981-1.136 1.308-1.623.49-.974.49-1.948 0-2.76-.49-.65-1.471-1.299-2.452-1.299-.49 0-.98.163-1.471.325-.49-.162-.98-.162-1.471-.162-.981 0-1.962.487-2.452 1.298-.49.812-.49 1.786 0 2.76.327.812.98 1.299 1.144 1.624zm5.067-3.41c.164.325.164.65 0 .974-.163.488-.654.812-.98 1.137-.327.325-.981.812-1.472 1.299-.49-.325-1.144-.974-1.47-1.3l-.164-.162c-.327-.324-.654-.649-.818-.974a1.028 1.028 0 010-.974c.164-.324.49-.486.981-.486.327 0 .654.162.818.324l.653.65.654-.65c.654-.487 1.471-.487 1.798.162z"
    ></path>
  </svg>
)


export default SvgAddIcon